import cx from 'classnames';
import clsx from 'clsx';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { ButtonProps } from '@ezugi/bootstrap/src/features/bet-toolbar/types';
import { useIntl } from '@ezugi/bootstrap/src/hooks/useIntl';
import { menuActions } from '@ezugi/bootstrap/src/store/actions';
import { ANALYTICS } from '@ezugi/bootstrap/src/store/constants';
import { Button } from '@ezugi/ui/components';
import { DeviceInfo } from '@ezugi/utils';

import CurrencyIcon from '../EvoGameFooter/CurrencyIcon';
import { betToolbarButtonBase, betToolbarButtonMobile, cashierButton } from './Button.css';
import * as style from './style.css';

const { cashier } = menuActions;

const intlKeys = {
  cashier: 'general.cashier',
};

const CashierButton = ({ className }: ButtonProps) => {
  const dispatch = useDispatch();

  const locales = useIntl({
    keys: intlKeys,
  });

  const openCashier = useCallback(
    () => dispatch(cashier.request({ source: ANALYTICS.CASHIER_SOURCE.CHIP_SELECTOR })),
    [ dispatch ]
  );

  return (
    <div className={clsx([ style.evoButton, style.cashierButton ])}>
      <Button
        data-testid="bet-toolbar-cashier-button"
        variant="raw"
        className={cx(
          cashierButton,
          betToolbarButtonBase,
          {
            [betToolbarButtonMobile]: DeviceInfo.isHandheld,
          },
          className
        )}
        onClick={openCashier}
        icon={<CurrencyIcon />}
      />
      <span className={clsx([ style.evoLabel, style.evoCashierLabel ])}>
        {locales.cashier}
      </span>
    </div>
  );
};

export default CashierButton;
